// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__8pq0o","subheader":"ReorderModal_subheader__2QrK2","listWrap":"ReorderModal_listWrap__2pu34"};